import { render, staticRenderFns } from "./groupUser.vue?vue&type=template&id=09331dbb&"
import script from "./groupUser.vue?vue&type=script&lang=js&"
export * from "./groupUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports